export default function ucFirst(str: string) {
	return str[0]?.toUpperCase() + str.substring(1);
}
